import React, { memo } from 'react';
import {
  defaultGeneralData,
  lineHeightStyle,
  styledComponent,
} from '../../../../utils/helpers';
import CommonDeleteBtn from '../commonDeleteBtn';

const GeneralExaminationView = ({
  prescriptionItems,
  selectedOnExamination,
  setSelectedOnExamination,
  isHistoryPage,
}) => {
  let { generalExaminations } = selectedOnExamination;

  const removeItemsData = (fieldName) => {
    const resetFields = defaultGeneralData();
    // Handle field reset
    if (fieldName in resetFields) {
      const resetValue = resetFields[fieldName];
      if (typeof resetValue === 'object') {
        generalExaminations[fieldName] = { ...resetValue };
      } else {
        generalExaminations[fieldName] = resetValue;
      }
    }

    // Update the state
    setSelectedOnExamination({
      ...selectedOnExamination,
      generalExaminations: { ...generalExaminations },
    });
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['on-examination']?.itemStyle || {},
  );
  const Value = styledComponent(
    prescriptionItems?.items?.['on-examination']?.subItemStyle || {},
  );

  return (
    <ul style={lineHeightStyle('on-examination', prescriptionItems)}>
      {generalExaminations['bloodGroup'] && (
        <li>
          <Title>Blood Group:</Title>{' '}
          <Value>{generalExaminations['bloodGroup']}</Value>
        </li>
      )}
      {(generalExaminations['bloodPressure'].systolic ||
        generalExaminations['bloodPressure'].diastolic) && (
        <li className="text-left">
          <Title>BP:</Title>{' '}
          <Value>
            {generalExaminations['bloodPressure'].systolic}/
            {generalExaminations['bloodPressure'].diastolic} mmHg
          </Value>
          {!isHistoryPage && (
            <CommonDeleteBtn
              action={removeItemsData}
              itemName={'bloodPressure'}
            />
          )}
        </li>
      )}
      {(generalExaminations['pulseInfo']['pulse'] ||
        generalExaminations['pulseInfo']['pulseType'] ||
        generalExaminations['pulseInfo']['note']) && (
        <li className="text-left">
          <Title>Pulse:</Title>{' '}
          <Value>
            {generalExaminations?.pulseInfo?.pulse &&
              `${generalExaminations.pulseInfo.pulse} ${
                generalExaminations.pulseInfo.pulseUnit === 'PM' ? 'PM' : 'BPM'
              }`}
            {generalExaminations['pulseInfo']['pulseType'] && (
              <span> ({generalExaminations['pulseInfo']['pulseType']})</span>
            )}
            {generalExaminations['pulseInfo']['note'] && (
              <span> - {generalExaminations['pulseInfo']['note']}</span>
            )}
          </Value>
          {!isHistoryPage && (
            <CommonDeleteBtn action={removeItemsData} itemName={'pulseInfo'} />
          )}
        </li>
      )}
      {generalExaminations?.respiratoryRate && (
        <li className="text-left">
          <Title>Respiratory Rate (RR):</Title>{' '}
          <Value>
            <span>{generalExaminations?.respiratoryRate} </span>
          </Value>
          {!isHistoryPage && (
            <CommonDeleteBtn
              action={removeItemsData}
              itemName={'respiratoryRate'}
            />
          )}
        </li>
      )}
      {generalExaminations['temperatureInfo']['temperature'] && (
        <li className="text-left">
          <Title>Temperature:</Title>{' '}
          <Value>
            {generalExaminations['temperatureInfo'].temperature + ' '}
            {generalExaminations['temperatureInfo']?.temperatureUnit}{' '}
            {generalExaminations['temperatureInfo']['temperatureType'] && (
              <span>
                ({generalExaminations['temperatureInfo']['temperatureType']})
              </span>
            )}
          </Value>
          {!isHistoryPage && (
            <CommonDeleteBtn
              action={removeItemsData}
              itemName={'temperatureInfo'}
            />
          )}
        </li>
      )}
      {!generalExaminations['temperatureInfo']['temperature'] &&
        generalExaminations['temperatureInfo'].temperatureType && (
          <li className="text-left">
            <Title>Temperature:</Title>{' '}
            <Value>
              {generalExaminations['temperatureInfo'].temperatureType && (
                <span>
                  {generalExaminations['temperatureInfo'].temperatureType}
                </span>
              )}
            </Value>
            {!isHistoryPage && (
              <CommonDeleteBtn
                action={removeItemsData}
                itemName={'temperatureInfo'}
              />
            )}
          </li>
        )}
      {generalExaminations['weightInfo']['weight'] &&
        !generalExaminations['weightInfo']['hideWeight'] && (
          <li className="text-left">
            <Title>Weight:</Title>{' '}
            <Value>
              {generalExaminations['weightInfo'].weight + ' '}
              {generalExaminations['weightInfo'].weightUnit}
            </Value>
            {!isHistoryPage && (
              <CommonDeleteBtn
                action={removeItemsData}
                itemName={'weightInfo'}
              />
            )}
          </li>
        )}
      {generalExaminations.bsa && generalExaminations.showBsa && (
        <li className="text-left">
          <Title>BSA:</Title> <Value>{generalExaminations?.bsa}</Value>
          {!isHistoryPage && (
            <CommonDeleteBtn action={removeItemsData} itemName={'bsa'} />
          )}
        </li>
      )}
      {(generalExaminations['heightInfo']['feet'] ||
        generalExaminations['heightInfo']['inch']) &&
        !generalExaminations['heightInfo']['hideHeight'] && (
          <li className="text-left">
            <Title>Height:</Title>{' '}
            <Value>
              {generalExaminations['heightInfo'].feet + '.'}
              {generalExaminations['heightInfo'].inch
                ? ' ' + generalExaminations['heightInfo'].inch
                : 0}
              {' ' + generalExaminations['heightInfo'].heightUnit}
            </Value>
            {!isHistoryPage && (
              <CommonDeleteBtn
                action={removeItemsData}
                itemName={'heightInfo'}
              />
            )}
          </li>
        )}
      {generalExaminations.bmi && generalExaminations.showBmi && (
        <li className="text-left">
          <Title>BMI:</Title> <Value>{generalExaminations?.bmi}</Value>
          {!isHistoryPage && (
            <CommonDeleteBtn action={removeItemsData} itemName={'bmi'} />
          )}
        </li>
      )}
      {generalExaminations?.idealWeightInfo?.idealWeight && (
        <li className="text-left">
          <Title>Ideal Weight:</Title>{' '}
          <Value>
            {generalExaminations?.idealWeightInfo?.idealWeight + ' '}
            {generalExaminations?.idealWeightInfo?.idealWeightUnit}
          </Value>
          {!isHistoryPage && (
            <CommonDeleteBtn
              action={removeItemsData}
              itemName={'idealWeightInfo'}
            />
          )}
        </li>
      )}
      {generalExaminations['idealBmi'] && (
        <li className="text-left">
          <Title>Ideal BMI:</Title>{' '}
          <Value>{generalExaminations['idealBmi']}</Value>
          {!isHistoryPage && (
            <CommonDeleteBtn action={removeItemsData} itemName={'idealBmi'} />
          )}
        </li>
      )}
      {generalExaminations['targetDailyCalory'] && (
        <li className="text-left">
          <Title>Target Daily Calory:</Title>{' '}
          <Value>{generalExaminations['targetDailyCalory']}</Value>
          {!isHistoryPage && (
            <CommonDeleteBtn
              action={removeItemsData}
              itemName={'targetDailyCalory'}
            />
          )}
        </li>
      )}
      {generalExaminations.diabetes && (
        <li className="text-left">
          <Title>Diabetes:</Title> <Value>{generalExaminations.diabetes}</Value>
          {!isHistoryPage && (
            <CommonDeleteBtn action={removeItemsData} itemName={'diabetes'} />
          )}
        </li>
      )}
    </ul>
  );
};

export default memo(GeneralExaminationView);
